export default "/fonts/vendor/mdui/dist/roboto/Roboto-LightItalic.woff2?4b2a79f0765ff216b9a3a7ce4b421e1b";